import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { LinkyModule } from 'ngx-linky';
import { CarouselModule } from 'primeng/carousel';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { USAuthenticationGuard } from 'src/app/shared/guard/user-auth-guard';
import { IndustryPipe } from 'src/app/shared/pipe/industry.pipe';
import { LocationPipe } from 'src/app/shared/pipe/location.pipe';
import { NamePipe } from 'src/app/shared/pipe/name.pipe';
import { PricePipe } from 'src/app/shared/pipe/price.pipe';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { BlogImgCardComponent } from './cards/blog-img-card/blog-img-card.component';
import { BuildWithListCardComponent } from './cards/build-with-list-card/build-with-list-card.component';
import { CompactCompanyCardComponent } from './cards/compact-company-card/compact-company-card.component';
import { CompanyCardComponent } from './cards/company-card/company-card.component';
import { CounterCardComponent } from './cards/counter-card/counter-card.component';
import { GoogleNewsCardComponent } from './cards/google-news-card/google-news-card.component';
import { GroupCompaniesCardComponent } from './cards/group-companies-card/group-companies-card.component';
import { MinimalCompanyCardComponent } from './cards/minimal-company-card/minimal-company-card.component';
import { MinimalUserCardComponent } from './cards/minimal-user-card/minimal-user-card.component';
import { RocDownloadCardComponent } from './cards/roc-download-card/roc-download-card.component';
import { UserCardComponent } from './cards/user-card/user-card.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { BlogComponentComponent } from './components/blog-component/blog-component.component';
import { BlogDetailsComponentComponent } from './components/blog-component/blog-details-component/blog-details-component.component';
import { CartComponentComponent } from './components/cart-component/cart-component.component';
import { CompanyDetailsComponentComponent } from './components/company-details-component/company-details-component.component';
import { CompanyListComponentComponent } from './components/company-list-component/company-list-component.component';
import { CompareCompanyComponentComponent } from './components/compare-company-component/compare-company-component.component';
import { HomeComponentComponent } from './components/home-component/home-component.component';
import { NgxTooltipComponentComponent } from './components/ngx-tooltip-component/ngx-tooltip-component.component';
import { PriceComponentComponent } from './components/price-component/price-component.component';
import { ProfileComponentComponent } from './components/profile-component/profile-component.component';
import { ReadMoreTextComponent } from './components/read-more-text/read-more-text.component';
import { TransactionComponentComponent } from './components/transaction-component/transaction-component.component';
import { CustomerRoutingModule } from './customer-routing.module';
import { BlogDetailsLayoutComponent } from './layouts/blog-layout/blog-details-layout/blog-details-layout.component';
import { BlogLayoutComponent } from './layouts/blog-layout/blog-layout.component';
import { CartLayoutComponent } from './layouts/cart-layout/cart-layout.component';
import { BlurFieldComponent } from './layouts/company-details-layout/blur-field/blur-field.component';
import { BuildWithListComponent } from './layouts/company-details-layout/build-with-list/build-with-list.component';
import { CompanyFinancialComponent } from './layouts/company-details-layout/company-financial/company-financial.component';
import { CompanyFundingComponent } from './layouts/company-details-layout/company-funding/company-funding.component';
import { CompanyNewsComponent } from './layouts/company-details-layout/company-news/company-news.component';
import { CompanyOverviewComponent } from './layouts/company-details-layout/company-overview/company-overview.component';
import { CompanyPeopleComponent } from './layouts/company-details-layout/company-people/company-people.component';
import { CompanyTractionComponent } from './layouts/company-details-layout/company-traction/company-traction.component';
import { CompetitorsListComponent } from './layouts/company-details-layout/competitors-list/competitors-list.component';
import { PeoplesListComponent } from './layouts/company-details-layout/peoples-list/peoples-list.component';
import { TechStackListComponent } from './layouts/company-details-layout/tech-stack-list/tech-stack-list.component';
import { CompactCompanyListComponent } from './layouts/company-list-layout/compact-company-list/compact-company-list.component';
import { CompanyFiltersComponent } from './layouts/company-list-layout/company-filters/company-filters.component';
import { CompanySortsComponent } from './layouts/company-list-layout/company-sorts/company-sorts.component';
import { HorizontalCompanyListComponent } from './layouts/company-list-layout/horizontal-company-list/horizontal-company-list.component';
import { VerticalCompanyListComponent } from './layouts/company-list-layout/vertical-company-list/vertical-company-list.component';
import { CompareComponent } from './layouts/home-layout/compare/compare.component';
import { DiscoverComponent } from './layouts/home-layout/discover/discover.component';
import { InterestedComponent } from './layouts/home-layout/interested/interested.component';
import { KredibleProComponent } from './layouts/home-layout/kredible-pro/kredible-pro.component';
import { QuoteSliderComponent } from './layouts/home-layout/quote-slider/quote-slider.component';
import { SearchComponent } from './layouts/home-layout/search/search.component';
import { MakePaymentLayoutComponent } from './layouts/make-payment-layout/make-payment-layout.component';
import { GoogleNewsLayoutComponent } from './layouts/news-layout/google-news-layout/google-news-layout.component';
import { NewsListComponent } from './layouts/news-layout/news-list/news-list.component';
import { NewsComponent } from './layouts/news-layout/news/news.component';
import { ProfileViewComponent } from './layouts/profile-view/profile-view.component';
import { TransactionLayoutComponent } from './layouts/transaction-layout/transaction-layout.component';
import { TransactionListLayoutComponent } from './layouts/transaction-list-layout/transaction-list-layout.component';
import { AboutUsPageComponent } from './pages/about-us-page/about-us-page.component';
import { BlogDetailsPageComponent } from './pages/blog-page/blog-details-page/blog-details-page.component';
import { BlogPageComponent } from './pages/blog-page/blog-page.component';
import { CareerPageComponent } from './pages/career-page/career-page.component';
import { CartPageComponent } from './pages/cart-page/cart-page.component';
import { CompanreCompanyPageComponent } from './pages/companre-company-page/companre-company-page.component';
import { CompanyDetailsPageComponent } from './pages/company-details-page/company-details-page.component';
import { CompanyListPageComponent } from './pages/company-list-page/company-list-page.component';
import { CompareCompanyPageComponent } from './pages/compare-company-page/compare-company-page.component';
import { ContactUsPageComponent } from './pages/contact-us-page/contact-us-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { MonetizingGatewayPageComponent } from './pages/monetizing-gateway-page/monetizing-gateway-page.component';
import { PartnersPageComponent } from './pages/partners-page/partners-page.component';
import { PricePageComponent } from './pages/price-page/price-page.component';
import { PrivacyPolicyPageComponent } from './pages/privacy-policy-page/privacy-policy-page.component';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { RefundPolicyPageComponent } from './pages/refund-policy-page/refund-policy-page.component';
import { SearchCompanyListPageComponent } from './pages/search-company-list-page/search-company-list-page.component';
import { TeamPageComponent } from './pages/team-page/team-page.component';
import { TermsAndConditionsPageComponent } from './pages/terms-and-conditions-page/terms-and-conditions-page.component';
import { TransactionPageComponent } from './pages/transaction-page/transaction-page.component';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContactUsFormComponent } from './forms/contact-us-form/contact-us-form.component';
import { ChangePasswordComponent } from './layouts/profile-view/change-password/change-password.component';
import { NotificationPageComponent } from './pages/notification-page/notification-page.component';
import { CompaniesFollowingComponent } from './pages/compnies-following/companies-following.component';
import { SafeHtmlPipe } from 'src/app/shared/pipe/safe-html.pipe';
import { InnerHtmlComponent } from './components/inner-html/inner-html.component';
import { NewCompanyRequestComponent } from './components/new-company-request/new-company-request.component';
import { SidebarModule } from 'primeng/sidebar';
import { MicroProductPageComponent } from './pages/micro-product-page/micro-product-page.component';
import { CompanyRocComponent } from './layouts/company-details-layout/company-roc/company-roc.component';
import { TransactionFailComponentComponent } from './components/transaction-fail-component/transaction-fail-component.component';
import { EmptyCartLayoutComponent } from './layouts/empty-cart-layout/empty-cart-layout.component';
import { PurchaseSubscriptionSuggestionLayoutComponent } from './layouts/purchase-subscription-suggestion-layout/purchase-subscription-suggestion-layout.component';
import { TransactionPendingComponentComponent } from './components/transaction-pending-component/transaction-pending-component.component';
import { CompanyStatusPipe } from 'src/app/shared/pipe/companyStatus.pipe';
import { MyRequestLayoutComponent } from './layouts/my-request-layout/my-request-layout.component';
import { CompanySideBarPageComponent } from './pages/company-details-page/company-side-bar-page/company-side-bar-page.component';
import { FeedsDetailsPageComponent } from './pages/feeds-details-page/feeds-details-page.component';
import { FeedsCompanyDetailsPageComponent } from './pages/feeds-details-page/feeds-company-details-page/feeds-company-details-page.component';
import { FeedsListPageComponent } from './pages/feeds-details-page/feeds-list-page/feeds-list-page.component';
import { FeedsReportPageComponent } from './pages/feeds-details-page/feeds-report-page/feeds-report-page.component';
import { FeedsLiveSaleCardComponent } from './components/feeds-live-sale-card/feeds-live-sale-card.component';
import { FeedsUserPostCardComponent } from './components/feeds-user-post-card/feeds-user-post-card.component';
import { FeedsCreativeCardComponent } from './components/feeds-graph-card/feeds-creative-card.component';
import { FeedsBlogsListCardComponent } from './components/feeds-blogs-list-card/feeds-blogs-list-card.component';
import { FeedsMarketingCardComponent } from './components/feeds-marketing-card/feeds-marketing-card.component';
import { FeedsProboCardComponent } from './components/feeds-probo-card/feeds-probo-card.component';
import { FeedsBuySubscriptionCardComponent } from './components/feeds-buy-subscription-card/feeds-buy-subscription-card.component';
import { FeedsCompanyCarouselCardComponent } from './components/feeds-free-sample-card/feeds-company-carousel-card.component';
import { FeedsCustomReportCardComponent } from './components/feeds-custom-report-card/feeds-custom-report-card.component';
import { FeedsSubscribeCardComponent } from './components/feeds-subscribe-card/feeds-subscribe-card.component';
import { CompanyListReportComponent } from './pages/company-list-page/company-list-report/company-list-report.component';
import { IndustryReportPageComponent } from './pages/industry-report-page/industry-report-page.component';
import { IndustryReportDetailsPageComponent } from './pages/industry-report-page/industry-report-details-page/industry-report-details-page.component';
import { IndustryReportActionPageComponent } from './pages/industry-report-page/industry-report-action-page/industry-report-action-page.component';
import { IndustryReportCompetitorPageComponent } from './pages/industry-report-page/industry-report-competitor-page/industry-report-competitor-page.component';
import { IndustryReportActionComponentComponent } from './components/industry-report-action-component/industry-report-action-component.component';
import { IndustryReportDetailsComponentComponent } from './components/industry-report-details-component/industry-report-details-component.component';
import { IndustryReportCompetitorComponentComponent } from './components/industry-report-competitor-component/industry-report-competitor-component.component';
import { CompanyRightSideBarPageComponent } from './pages/company-details-page/company-right-side-bar-page/company-right-side-bar-page.component';
import { IndustryReportSuggestionCardComponent } from './cards/industry-report-suggestion-card/industry-report-suggestion-card.component';
import { DownloadReportFormPopupComponent } from './forms/download-report-form-popup/download-report-form-popup.component';
import { FeedCreatePostComponent } from './components/feed-create-post/feed-create-post.component';
import { FeedCreatePostPopupComponent } from './components/feed-create-post-popup/feed-create-post-popup.component';
import { MicroProductRightSideBarPageComponent } from './pages/micro-product-page/micro-product-right-side-bar-page/micro-product-right-side-bar-page.component';
import { MicroProductListPageComponent } from './pages/micro-product-page/micro-product-list-page/micro-product-list-page.component';
import { PriceRightSideBarPageComponent } from './pages/price-page/price-right-side-bar-page/price-right-side-bar-page.component';
import { FeedDetailsPageComponent } from './pages/feed-details-page/feed-details-page.component';
import { FeedDetailsRightSideBarPageComponent } from './pages/feed-details-page/feed-details-right-side-bar-page/feed-details-right-side-bar-page.component';
import { FeedDetailsComponentComponent } from './components/feed-details-component/feed-details-component.component';
import { MicroProductDetailsPageComponent } from './pages/micro-product-details-page/micro-product-details-page.component';
import { MicroProductDetailPageComponent } from './pages/micro-product-details-page/micro-product-detail-page/micro-product-detail-page.component';
import { MicroProductRightSideBarComponent } from './pages/micro-product-details-page/micro-product-right-side-bar/micro-product-right-side-bar.component';
import { MicroProductLeftSideBarComponent } from './pages/micro-product-details-page/micro-product-left-side-bar/micro-product-left-side-bar.component';
import { ProfilePageLeftSideBarComponent } from './pages/profile-page/profile-page-left-side-bar/profile-page-left-side-bar.component';
import { ProfilePageRightSideBarComponent } from './pages/profile-page/profile-page-right-side-bar/profile-page-right-side-bar.component';
import { CartRightSideBarPageComponent } from './pages/cart-page/cart-right-side-bar-page/cart-right-side-bar-page.component';
import { CartLeftSideBarPageComponent } from './pages/cart-page/cart-left-side-bar-page/cart-left-side-bar-page.component';
import { MicroProductFiltersComponent } from './pages/micro-product-page/micro-product-filters/micro-product-filters.component';
import { SliderModule } from 'primeng/slider';
import { IframeScalerComponent } from './layouts/iframe-scaler/iframe-scaler.component';
import { CompanySampleReportPageComponent } from './pages/company-sample-report-page/company-sample-report-page.component';
import { CompanySampleReportDetialsPageComponent } from './pages/company-sample-report-page/company-sample-report-detials-page/company-sample-report-detials-page.component';
import { SocialService } from 'src/app/shared/services/angular-service/social.service';
import { IndustryReportSuggestionComponent } from './components/industry-report-suggestion/industry-report-suggestion.component';
import { ProboPortfolioComponent } from "./components/probo-portfolio/probo-portfolio.component";
import { FeedProboDetailsComponent } from './components/feed-probo-details/feed-probo-details.component';
import { CompanyTypePipe } from 'src/app/shared/pipe/companyType.pipe';
import { ReportSubscriptionPageComponent } from './pages/report-subscription-page/report-subscription-page.component';
import { CustomerDemandReportComponent } from './pages/customer-demand-report/customer-demand-report.component';
import { ReportSubscriptionComponent } from './pages/report-subscription/report-subscription.component';
import { CustomerDemandComponent } from './pages/customer-demand/customer-demand.component';
import { CompanyTimelineComponent } from './layouts/company-details-layout/company-timeline/company-timeline.component';
import { DownloadFinancialReportComponent } from './pages/download-financial-report/download-financial-report.component';
import { FinancialDocumentComponent } from './pages/download-financial-report/financial-document/financial-document.component';
import { ProfileNavPageComponent } from './pages/profile-page/profile-nav-page/profile-nav-page.component';
import { FinancialReportPageComponent } from './pages/financial-report-page/financial-report-page.component';
import { MoreOptionsComponent } from './pages/more-options/more-options.component';

@NgModule({
  declarations: [
    HomePageComponent,
    SearchComponent,
    InterestedComponent,
    KredibleProComponent,
    CompareComponent,
    NewsComponent,
    DiscoverComponent,
    AboutUsPageComponent,
    CompanyListComponentComponent,
    CompanyListPageComponent,
    HomeComponentComponent,
    CompanyCardComponent,
    HorizontalCompanyListComponent,
    VerticalCompanyListComponent,
    CompactCompanyCardComponent,
    CompactCompanyListComponent,
    CompanyFiltersComponent,
    CompanySortsComponent,
    CompanyOverviewComponent,
    CompanyFundingComponent,
    CompanyFinancialComponent,
    CompanyTractionComponent,
    CompanyPeopleComponent,
    CompanyNewsComponent,
    GoogleNewsLayoutComponent,
    QuoteSliderComponent,
    GoogleNewsCardComponent,
    MinimalCompanyCardComponent,
    MinimalUserCardComponent,
    UserCardComponent,
    CompetitorsListComponent,
    CounterCardComponent,
    PeoplesListComponent,
    TechStackListComponent,
    BuildWithListComponent,
    NewsListComponent,
    BuildWithListCardComponent,
    PricePageComponent,
    PriceComponentComponent,
    RocDownloadCardComponent,
    AboutUsComponent,
    CompactCompanyCardComponent,
    CompanyDetailsComponentComponent,
    CompanyDetailsPageComponent,
    CompactCompanyCardComponent,
    ReadMoreTextComponent,
    CompanreCompanyPageComponent,
    CompareCompanyPageComponent,
    CompareCompanyComponentComponent,
    ProfilePageComponent,
    ProfileComponentComponent,
    ProfileViewComponent,
    CartComponentComponent,
    TransactionComponentComponent,
    TransactionLayoutComponent,
    CartLayoutComponent,
    CartPageComponent,
    TransactionPageComponent,
    TransactionListLayoutComponent,
    TermsAndConditionsPageComponent,
    PrivacyPolicyPageComponent,
    GroupCompaniesCardComponent,
    ContactUsPageComponent,
    PartnersPageComponent,
    CareerPageComponent,
    RefundPolicyPageComponent,
    MonetizingGatewayPageComponent,
    BlurFieldComponent,
    BlogPageComponent,
    BlogComponentComponent,
    BlogLayoutComponent,
    BlogDetailsLayoutComponent,
    BlogDetailsComponentComponent,
    BlogDetailsPageComponent,
    BlogImgCardComponent,
    IndustryPipe,
    CompanyStatusPipe,
    CompanyTypePipe,
    LocationPipe,
    PricePipe,
    NamePipe,
    SafeHtmlPipe,
    NgxTooltipComponentComponent,
    SearchCompanyListPageComponent,
    TeamPageComponent,
    MakePaymentLayoutComponent,
    ChangePasswordComponent,
    ContactUsFormComponent,
    NotificationPageComponent,
    CompaniesFollowingComponent,
    InnerHtmlComponent,
    NewCompanyRequestComponent,
    MicroProductPageComponent,
    CompanyRocComponent,
    CompanyTimelineComponent,
    TransactionFailComponentComponent,
    EmptyCartLayoutComponent,
    PurchaseSubscriptionSuggestionLayoutComponent,
    TransactionPendingComponentComponent,
    MyRequestLayoutComponent,
    CompanySideBarPageComponent,
    FeedsDetailsPageComponent,
    FeedsCompanyDetailsPageComponent,
    FeedsListPageComponent,
    FeedsReportPageComponent,
    FeedsLiveSaleCardComponent,
    FeedsUserPostCardComponent,
    FeedsCreativeCardComponent,
    FeedsBlogsListCardComponent,
    FeedsMarketingCardComponent,
    FeedsProboCardComponent,
    FeedsBuySubscriptionCardComponent,
    FeedsCompanyCarouselCardComponent,
    FeedsCustomReportCardComponent,
    FeedsSubscribeCardComponent,
    CompanyListReportComponent,
    IndustryReportPageComponent,
    IndustryReportDetailsPageComponent,
    IndustryReportActionPageComponent,
    IndustryReportCompetitorPageComponent,
    IndustryReportActionComponentComponent,
    IndustryReportDetailsComponentComponent,
    IndustryReportCompetitorComponentComponent,
    CompanyRightSideBarPageComponent,
    IndustryReportSuggestionCardComponent,
    DownloadReportFormPopupComponent,
    FeedCreatePostComponent,
    FeedCreatePostPopupComponent,
    MicroProductRightSideBarPageComponent,
    MicroProductListPageComponent,
    PriceRightSideBarPageComponent,
    FeedDetailsPageComponent,
    FeedDetailsRightSideBarPageComponent,
    FeedDetailsComponentComponent,
    MicroProductDetailsPageComponent,
    MicroProductDetailPageComponent,
    MicroProductRightSideBarComponent,
    MicroProductLeftSideBarComponent,
    ProfilePageLeftSideBarComponent,
    ProfilePageRightSideBarComponent,
    CartRightSideBarPageComponent,
    CartLeftSideBarPageComponent,
    MicroProductFiltersComponent,
    IframeScalerComponent,
    CompanySampleReportPageComponent,
    CompanySampleReportDetialsPageComponent,
    IndustryReportSuggestionComponent,
    ReportSubscriptionPageComponent,
    CustomerDemandReportComponent,
    CustomerDemandComponent,
    ReportSubscriptionComponent,
    FeedProboDetailsComponent,
    DownloadFinancialReportComponent,
    FinancialDocumentComponent,
    ProfileNavPageComponent,
    FinancialReportPageComponent,
    MoreOptionsComponent
  ],
  imports: [
    DropdownModule,
    CustomerRoutingModule,
    CarouselModule,
    LinkyModule,
    NgxChartsModule,
    ReactiveFormsModule,
    FormsModule,
    ConfirmPopupModule,
    ConfirmDialogModule,
    DialogModule,
    SharedModule,
    SidebarModule,
    SliderModule,
    ProboPortfolioComponent
],
  providers: [
    USAuthenticationGuard,
    CompanyService,
    ConfirmationService,
    SocialService,
  ],
})
export class CustomerModule {}
